var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.99 2.2175L9.49 0.1575C8.92 -0.0525 7.99 -0.0525 7.42 0.1575L1.92 2.2175C0.86 2.6175 0 3.8575 0 4.9875V13.0875C0 13.8975 0.53 14.9675 1.18 15.4475L6.68 19.5575C7.65 20.2875 9.24 20.2875 10.21 19.5575L15.71 15.4475C16.36 14.9575 16.89 13.8975 16.89 13.0875V4.9875C16.9 3.8575 16.04 2.6175 14.99 2.2175ZM11.93 7.8175L7.63 12.1175C7.48 12.2675 7.29 12.3375 7.1 12.3375C6.91 12.3375 6.72 12.2675 6.57 12.1175L4.97 10.4975C4.68 10.2075 4.68 9.7275 4.97 9.4375C5.26 9.1475 5.74 9.1475 6.03 9.4375L7.11 10.5175L10.88 6.7475C11.17 6.4575 11.65 6.4575 11.94 6.7475C12.23 7.0375 12.23 7.5275 11.93 7.8175Z",
    fill: "#9135E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldColored);
export default __webpack_public_path__ + "static/media/shield-colored.7677045ae9c2c2618e1940f428a3008c.svg";
export { ForwardRef as ReactComponent };